import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const PdfViewer = ({ show, handleClose, title, children }) => {
  return (
    <Dialog
      visible={show}
      onHide={handleClose}
      header={<i style={{ color: "#323639", fontSize: "1.3rem", textAlign: "center" }}>{title}</i>}
      footer={
        <div className="p-d-flex p-jc-end">
          <Button label="Cerrar" icon="pi pi-times" onClick={handleClose} className="p-button-secondary" />
        </div>
      }
      style={{ width: "80vw" }} // Adjust size as needed
      breakpoints={{ "960px": "75vw", "640px": "90vw" }} // Adjust for responsiveness
      maximizable
    >
      {children}
    </Dialog>
  );
};

export default PdfViewer;
